import React, { useCallback, useEffect, useState } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  Col,
  Row,
} from "reactstrap"

import ApiService from '../../../Services/ApiService';
import AlertService from '../../../Services/alertService'
import { ADMIN_USER_TYPE_ID, ERROR_KEY, MERCHANT_USER_TYPE_ID } from '../../../Constants/MainKeys'
import uuid from 'react-uuid'
import { addRightSectionSpinner, removeRightSectionSpinner } from '../../../store/spinner/actions'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import TotalOrder from './Components/TotalOrder';
import QuickView from './Components/QuickView';
import TransactionDetails from './Components/TransactionDetails';
import HedgingProfitAndTransactionFeeDetails from './Components/HedgingProfitAndTransactionFeeDetails';
import TransactionReceipt from './Components/TransactionReceipt';
import { useLocation } from 'react-router-dom';
import TotalFees from './Components/TotalFees';

const CurrentTransaction = (props) => {

  const { transactionId, organizationId } = props.match.params;
  const { pathname } = useLocation();

  const isInstantPaymentPage = pathname.includes("instant-payment");

  const title = `${isInstantPaymentPage ? "Instant Payment" : "Transaction"} Overview`;
  const description = "";
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.Login);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { language } = useSelector(state => state.Languages);
  const [organizers, setOrganizers] = useState(null);
  const [transactionOverview, setTransactionOverview] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [payignCustomer, setPayignCustomer] = useState(null);

  useEffect(() => {
    getTransactionOrganizers();
    getTransactionOverview();
    getTransactionDetails();
    getPayingCustomer();
  }, [transactionId, organizationId])

  const getTransactionOrganizers = () => {
    if (!organizationId) { return false };
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getTransactionOrganizers(organizationId).then(response => {
      if (response && response.data) {
        setOrganizers(response.data)
      }
    }).catch(error => AlertService.alert(ERROR_KEY, error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    });
  }

  const getPayingCustomer = () => {
    if (user.userTypeId === MERCHANT_USER_TYPE_ID) { return false; }
    if (!transactionId) { return false };
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getPayingCustomer(transactionId).then(response => {
      if (response && response.data) {
        setPayignCustomer(response.data)
      }

    }).catch(error => AlertService.alert(ERROR_KEY, error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    });
  }

  const getTransactionOverview = () => {
    if (!transactionId) { return false };
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getTransactionOverview(transactionId).then(response => {
      if (response && response.data) {
        setTransactionOverview(response.data)
      }
    }).catch(error => AlertService.alert(ERROR_KEY, error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    });
  }

  const getTransactionDetails = () => {
    if (!transactionId) { return false };
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    (user?.userTypeId === MERCHANT_USER_TYPE_ID ?
      ApiService.getTransactionDetailsAsMerchant(transactionId) :
      ApiService.getTransactionDetails(transactionId)).then(response => {
        if (response && response.data) {
          setTransactionDetails(response.data)
        }
      }).catch(error => AlertService.alert(ERROR_KEY, error)).finally(() => {
        extractRightSectionSpinner(spinnerId);
      });
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />

        <div className="container-fluid">
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem={`${isInstantPaymentPage ? "Instant Payment" : "Transaction"} Overview`}
            isShowGoBackButton={true}
            goBack={() => window.history.back()}
          />
          <Row>
            <Col lg={12}>
              <Row className='mb-4'>
                <Col xl={5}>
                  <Row>
                    <Col sm={12}>
                      <TotalOrder
                        transactionOverview={transactionOverview}
                        transactionDetails={transactionDetails}
                        isInstantPaymentPage={isInstantPaymentPage}
                      />
                    </Col>
                    {/* <Col sm={12}>
                      <TransactionDetails
                        transactionDetails={transactionDetails}
                        isInstantPaymentPage={isInstantPaymentPage}
                      />
                    </Col> */}

                  </Row>

                </Col>
                <Col xl={7}>
                  <Row>
                    {
                      transactionDetails || organizers ?
                        <Col sm={12}>
                          <QuickView
                            isInstantPaymentPage={isInstantPaymentPage}
                            data={organizers}
                            transactionDetails={transactionDetails}
                          />
                        </Col>
                        : null
                    }
                    {/* {
                      isInstantPaymentPage || user?.userTypeId === MERCHANT_USER_TYPE_ID ? null :
                        <Col sm={12}>
                          <HedgingProfitAndTransactionFeeDetails />
                        </Col>
                    } */}
                    {/* {
                      isInstantPaymentPage || user?.userTypeId === ADMIN_USER_TYPE_ID ? null :
                        <Col sm={12}>
                          <TotalFees />
                        </Col>
                    } */}
                    <Col sm={12}>
                      <TransactionReceipt />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default CurrentTransaction